var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ArrowUpward } from '@mui/icons-material';
import { Box, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { setTaskSortSelectedItem } from 'app/actions/map';
import { Autosizer, Scrollbar } from 'app/components';
import { sortItemsTaskListMapSelector, taskColumnCheckedItemsMapSelector, taskSelectedItemMapSelector, taskSortSelectedItemMapSelector, } from 'app/selectors/map';
import { taskSelectedLoad } from 'app/store/map';
import React, { createContext, forwardRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TASK_STATUS_LABELS = {
    finished: 'Завершено',
    active: 'Активно',
};
const MapFilterTaskListContext = createContext(null);
const MapFilterTaskList = () => {
    const dispatch = useDispatch();
    const taskSortSelectedItem = useSelector(taskSortSelectedItemMapSelector);
    const taskColumnCheckedItems = useSelector(taskColumnCheckedItemsMapSelector);
    const taskSelectedItem = useSelector(taskSelectedItemMapSelector);
    const sortItems = useSelector(sortItemsTaskListMapSelector);
    const columns = useMemo(() => {
        return config.mapTaskColumns.filter((column) => taskColumnCheckedItems.includes(column.name));
    }, [taskColumnCheckedItems]);
    const handleSortClick = (value) => dispatch(setTaskSortSelectedItem(value));
    const handleItemClick = (value) => {
        dispatch(taskSelectedLoad(value));
    };
    return (React.createElement(Box, { sx: {
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
        } },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(MapFilterTaskListContext.Provider, { value: {
                    columns,
                    onSortClick: handleSortClick,
                    sortSelectedItem: taskSortSelectedItem,
                } },
                React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, innerElementType: innerElementType, itemCount: sortItems.length, itemSize: 24, overscanCount: 10, innerRef: contentNodeRef, outerRef: scrollableNodeRef, itemData: {
                        items: sortItems,
                        columns,
                        selectedItem: taskSelectedItem,
                        onClick: handleItemClick,
                    } }, StickyListItem)))))))));
};
const innerElementType = forwardRef((_a, ref) => {
    var { children, style } = _a, rest = __rest(_a, ["children", "style"]);
    return (React.createElement(MapFilterTaskListContext.Consumer, null, (context) => {
        if (!context) {
            return null;
        }
        const { columns, onSortClick, sortSelectedItem } = context;
        return (React.createElement("div", Object.assign({ ref: ref, style: style }, rest),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: style === null || style === void 0 ? void 0 : style.height,
                    minHeight: '100%',
                    zIndex: '2',
                    pointerEvents: 'none',
                    padding: theme.spacing(0),
                    '.MuiListItemText-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '100%',
                        position: 'relative',
                        flex: 'none',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            height: '100%',
                            bgcolor: theme.palette.divider,
                            width: '1px',
                            zIndex: '1',
                            pointerEvents: 'none',
                        },
                        '&:last-of-type': {
                            flex: '1',
                            '&:before': {
                                display: 'none',
                            },
                        },
                    },
                }) }, columns.map((column) => (React.createElement(ListItemText, { key: column.name, style: { width: column.width } })))),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'sticky',
                    top: '0',
                    width: '100%',
                    display: 'flex',
                    zIndex: '1',
                    '.MuiListItemButton-root': {
                        display: 'flex',
                        flex: 'none',
                        height: '30px',
                        padding: theme.spacing(0),
                        position: 'relative',
                        bgcolor: 'background.default',
                        borderColor: theme.palette.divider,
                        '&:first-of-type': {
                            '.MuiListItemText-root': {
                                paddingLeft: '31px',
                            },
                        },
                        '&:last-of-type': {
                            flex: '1',
                            '.MuiListItemText-root': {
                                paddingRight: theme.spacing(2),
                            },
                        },
                        '.MuiTouchRipple-rippleVisible': {
                            color: 'inherit',
                        },
                        '.MuiListItemText-root': {
                            display: 'flex',
                            cursor: 'pointer',
                            margin: theme.spacing(0),
                            padding: '6px 6px',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            '.MuiTypography-root': {
                                display: 'flex',
                                '&:nth-of-type(1)': {
                                    color: 'text.secondary',
                                    marginRight: '4px',
                                },
                                '&:nth-of-type(2) svg': {
                                    fontSize: '12px',
                                    transition: 'all 300ms',
                                    transform: 'rotateZ(0deg)',
                                },
                            },
                        },
                    },
                }) }, columns.map((column) => (React.createElement(ListItemButton, { key: column.name, onClick: () => onSortClick(column), disableTouchRipple: !column.order, sx: (theme) => ({
                    minWidth: column.width,
                    '.MuiListItemText-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        '.MuiTypography-root': {
                            width: 'auto',
                            '&:nth-of-type(2)': Object.assign({ opacity: '0.2', transform: 'rotateZ(0)', transition: 'transform ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms' }, (sortSelectedItem.name === column.name && Object.assign({ opacity: '1' }, (sortSelectedItem.order === 'DESC' && {
                                transform: 'rotateZ(180deg)',
                            })))),
                        },
                    },
                }) },
                React.createElement(ListItemText, { disableTypography: true },
                    React.createElement(Typography, null, column.label),
                    React.createElement(Typography, null, column.order && React.createElement(ArrowUpward, { fontSize: 'small' }))))))),
            children));
    }));
});
innerElementType.displayName = 'MapFilterTaskListInnerElement';
const StickyListItem = ({ data, index, style }) => {
    const { items, columns, selectedItem, onClick } = data;
    const item = items[index];
    const statusLabel = TASK_STATUS_LABELS[String(item.status)];
    return (React.createElement(ListItem, { key: index, disablePadding: true, style: style, selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id, onClick: () => onClick(item), sx: (theme) => (Object.assign(Object.assign(Object.assign({ width: '100%', marginTop: '30px', userSelect: 'none', borderRadius: '0', '&:hover': {
                '.MuiListItemText-root': {
                    cursor: 'pointer',
                },
            }, '&.Mui-selected': {
                '.MuiListItemText-root': {
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                },
                '.MuiCheckbox-root': {
                    color: theme.palette.primary.contrastText,
                    '&.Mui-checked': {
                        color: theme.palette.primary.contrastText,
                    },
                },
            }, '.MuiListItemText-root': {
                display: 'flex',
                flex: 'none',
                height: '100%',
                margin: theme.spacing(0),
                padding: theme.spacing(0.5, 1),
                alignItems: 'center',
                '&:first-of-type': {
                    paddingLeft: theme.spacing(2),
                    svg: {
                        fontSize: '16px',
                        marginRight: '3px',
                    },
                },
                '&:last-of-type': {
                    flex: '1',
                    paddingRight: theme.spacing(2),
                },
                '.MuiTypography-root': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                },
                '.MuiCheckbox-root': {
                    padding: theme.spacing(0),
                    marginLeft: '-2px',
                    svg: {
                        fontSize: '18px',
                    },
                },
            } }, ((items.length - (items.length - 1 - index)) % 2 === 0 && {
            '& .MuiListItemText-root': {
                bgcolor: 'background.default',
            },
        })), (item.status === 'active' && {
            '& .MuiListItemText-root': {
                color: theme.palette.success.contrastText,
                bgcolor: theme.palette.success.light,
            },
            '&:hover': {
                cursor: 'pointer',
                '& .MuiListItemText-root': {
                    bgcolor: theme.palette.success.light,
                },
            },
        })), (item.status === 'finished' && {
            '&:hover': {
                cursor: 'pointer',
            },
        }))) }, columns.map((column) => {
        switch (column.name) {
            case 'id':
                return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { minWidth: column.width } },
                    React.createElement(Typography, null, item.id)));
            case 'status':
                return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { minWidth: column.width } },
                    React.createElement(Typography, null, statusLabel)));
            case 'transport_number':
                return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { minWidth: column.width } },
                    React.createElement(Typography, null,
                        item.transport_number,
                        "_",
                        moment(item.task_date).format('YY.MM.DD HH:mm').replace(/\D/g, ''))));
            case 'task_date':
                return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { minWidth: column.width } },
                    React.createElement(Typography, null, moment(item.task_date).format('DD.MM.YYYY HH:mm'))));
            case 'finished_date':
                return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { minWidth: column.width } },
                    React.createElement(Typography, null, moment(item.finished_date).isValid() && moment(item.finished_date).format('DD.MM.YYYY HH:mm'))));
            default:
                return null;
        }
    })));
};
export default MapFilterTaskList;
